import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { getUser } from '../../../../../api/user-api';
import { selectAddressVerificationStatus } from '../../../../../features/user/verificationSlices/addressVerifcationSlice';
import { selectDebtVerificationStatus } from '../../../../../features/user/verificationSlices/debtVerificationSlice';

export default function ProfileSummary() {
  const debtVerified = useSelector(selectDebtVerificationStatus);
  const userHasBVN = useSelector((state) => state.user.data?.bvn);
  const addressVerified = useSelector(selectAddressVerificationStatus);
  const userHasAddress = useSelector(
    (state) => state.user.data?.residentialAddress
  );

  const isVerified =
    (debtVerified && addressVerified) || (userHasBVN && userHasAddress);

  const { data: user } = useSelector((state) => state.user);
  const isTier2 = user?.isTier2;
  const isTier1 = true;

  const { register } = useForm({
    defaultValues: {
      firstName: user?.firstName || '',
      lastName: user?.lastName || '',
      email: user?.email || '',
      phoneNumber: user?.phoneNumber || '',
    },
  });

  const address = user?.residentialAddress;
  const city = user?.residentialCity;
  const state = user?.residentialState;

  return (
    <div className="px-2 lg:px-6 font-duplet">
      <h2 className="text-[23px] font-semibold mb-6 ">Profile</h2>
      <hr />
      <div className="grid gap-3 lg:flex justify-between items-start my-4">
        {isTier1 && !isTier2 && (
          <div className="border border-gray-200 rounded p-4 lg:w-[30%] text-sm">
            <div className="flex justify-between">
              <p className="font-semibold">Your membership</p>
              {!isVerified && (
                <a
                  href="/user-dashboard/account-profile/account-verification"
                  className="underline text-xs"
                >
                  Verify account
                </a>
              )}
            </div>
            <p className="text-lg font-bold text-gray-800">Tier 1</p>
            <hr />
            <p className="mt-2 text-xs text-gray-600">
              You have access to buy items up to ₦500k
            </p>
          </div>
        )}

        {!isTier2 && (
          <div className="text-center text-sm">
            <button
              className="bg-[var(--yellow-primary)] text-black font-semibold px-6 py-2 rounded cursor-not-allowed"
              disabled
              // onClick={() => (window.location.href = 'user-dashboard/account-profile/account-verification')}
            >
              Upgrade to Tier
            </button>
            <p className="mt-1 text-xs">
              Unlock Tier 2 to enjoy exclusive access to items valued at N500k
              and above.
            </p>
          </div>
        )}

        {isTier2 && (
          <div className="hidden lg:block border border-gray-200 rounded p-4 lg:w-[30%] text-sm">
            <p className="font-semibold">Your membership</p>
            <p className="text-lg font-bold text-gray-800">Tier 2</p>
            <hr />
            <p className="mt-2 text-xs text-gray-600">
              You have access to buy items up to ₦1m
            </p>
          </div>
        )}
      </div>
      <hr className="my-2 w-[90%]" />
      <form className="space-y-6 lg:w-[90%]">
        <div className="grid lg:grid-cols-[40%_1fr] gap-4 my-4 items-center">
          <p className="font-semibold text-sm">First name & Last name</p>
          <div className="flex justify-between w-full space-x-1 lg:space-x-3">
            <label htmlFor="firstName" className="lg:w-1/2">
              <input
                type="text"
                id="firstName"
                disabled
                placeholder="First name"
                {...register('firstName')}
                className="border p-2 rounded w-full text-gray-400 font-medium"
              />
            </label>
            <label htmlFor="lastName" className="lg:w-1/2">
              <input
                id="lastName"
                disabled
                type="text"
                placeholder="Last name"
                {...register('lastName')}
                className="border p-2 rounded w-full text-gray-400 font-medium"
              />
            </label>
          </div>
        </div>

        <hr />
        <div className="my-4">
          <div className="grid lg:grid-cols-[40%_55%] gap-4 my-4 items-center">
            <p className="font-semibold text-sm">Email</p>
            <label htmlFor="email" className="lg:w-1/2">
              <input
                disabled
                id="email"
                type="email"
                placeholder="Email"
                {...register('email')}
                className="border p-2 rounded w-full text-gray-400 font-medium"
              />
            </label>
          </div>

          <div className="grid lg:grid-cols-[40%_55%] gap-4 my-4 items-center">
            <p className="font-semibold text-sm">Phone</p>
            <label htmlFor="phoneNumber" className="lg:w-1/2">
              <input
                disabled
                id="phoneNumber"
                type="text"
                placeholder="Phone number"
                {...register('phoneNumber')}
                className="border p-2 rounded w-full text-gray-400 font-medium"
              />
            </label>
          </div>
        </div>

        <hr />
      </form>

      <div className="grid lg:grid-cols-[38%_50%]  my-4 items-start">
        <p className="font-semibold text-sm">Home address</p>
        <p className="font-duplet">
          {address && city && state ? (
            <>
              {address}, {city}, {state}
            </>
          ) : (
            ''
          )}
        </p>
      </div>
    </div>
  );
}
